import { LogOut, ShieldAlert, Smartphone } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { getRoleLabel } from '../constants/roles.js'
import { useAuth } from '../hooks/useAuth.js'

export default function AdminAccessPage() {
  const navigate = useNavigate()
  const { logout, user } = useAuth()

  const handleLogout = async () => {
    await logout()
    navigate('/login', { replace: true })
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="w-full max-w-lg card p-8 text-center">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-amber-50 text-amber-600">
          <ShieldAlert className="h-7 w-7" />
        </div>
        <h1 className="mt-5 text-2xl font-bold text-gray-900">Admin Access Only</h1>
        <p className="mt-3 text-sm leading-relaxed text-gray-500">
          This BrainCamp web portal is aligned to the BrainCamp admin workspace and is only available for
          `admin` and `super_admin` accounts.
        </p>

        <div className="mt-6 rounded-2xl border border-blue-100 bg-blue-50 px-4 py-4 text-left">
          <div className="flex items-start gap-3">
            <Smartphone className="mt-0.5 h-5 w-5 flex-shrink-0 text-blue-600" />
            <div>
              <p className="text-sm font-semibold text-blue-900">
                Signed in as {user?.name || 'a user'} ({getRoleLabel(user?.role)})
              </p>
              <p className="mt-1 text-sm text-blue-800">
                Teachers, parents, and students should continue using the BrainCamp mobile app for their role-based workflows.
              </p>
            </div>
          </div>
        </div>

        <button onClick={handleLogout} className="btn-primary mt-6 w-full">
          <LogOut className="h-4 w-4" /> Sign Out
        </button>
      </div>
    </div>
  )
}
